import Plugins, { Layout as _Layout } from "@charrue/layout-internal";

export const Layout = _Layout;
export default Plugins;
